import React from "react";
import { Link } from "react-router-dom";

function Smartcity() {
  return (
    <div>
      <section
        className="page-title"
        style={{
          backgroundImage: "url(../images/background/bg-page-title-1.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>스마트 서비스</h1>
          <div className="bread-crumb-outer">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">스마트 시티 서비스</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="feature-style-1">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 company">
              <div className="company-tab">
                      <ul className="nav nav-pills nav-justified">
                        <li className="active">
                          <Link data-toggle="pill" to="/smartcity">
                            스마트시티서비스{" "}
                          </Link>
                        </li>
                        <li>
                          <Link data-toggle="pill" to="/safe">
                            안전 플랫폼{" "}
                          </Link>
                        </li>
                        <li>
                          <Link data-toggle="pill" to="/sims">
                            SIMS{"  "}
                          </Link>
                        </li>
                      </ul>
                <div className="tab-content">
                    {/* <!--Title--> */}                  
                        <div className='tab_content_area'>
                                    <div className="tab_title">
                                        스마트 시티 서비스
                                    </div>
                                    <div className='tab_paragraph'>
                                        <p>개요</p>
                                        <div className='tab_brackets'></div>
                                            <ul>
                                                <li>- 전국 지자체에서 도시 문제, 물류, 환경분야 등 스마트 시티 서비스 공공 사업 추진중</li>
                                                <li>- 20개 지자체 사업 진행 중이며 46개 지자체 협업 진행</li>
                                            </ul>
                                        <div className='servicePostBox6'>
                                            <div  className='servicePostCard5'>
                                                <p>스마트 시티</p>
                                                <div className='tab_brackets2'></div>
                                                <div className="servicePostCard5_text">
                                                  <ul>
                                                      <li>- 창원시 지역거점 스마트시티 조성사업, 김천시/양양군 스마트타운 챌린지 사업 추진 중</li>
                                                  </ul>
                                                </div>
                                                    <img className='ssvImg1' src='./images/service/Data/image26.png' alt=''/>
                                            </div>
                                            <div  className='servicePostCard5'>
                                                <p>스마트 솔루션 확산/ 도시 재생 스마트 기술</p>
                                                <div className='tab_brackets2'></div>
                                                <div >
                                                  <ul>
                                                      <li>- 수원/성남시 스마트시티 솔루션 확산 사업</li>
                                                      <li>- 안산/인천시 생활밀착형 도시 재생 스마트 기술사업 추진 중</li>
                                                  </ul>
                                                </div>
                                                    <img src='./images/service/Data/image27.png'alt=''/>
                                            </div>
                                            <div  className='servicePostCard5'>
                                                <p>디지털 물류 서비스</p>
                                                <div className='tab_brackets2'></div>
                                                <div className="servicePostCard5_text">
                                                  <ul>
                                                      <li>- 김천 구도시의 로봇/드론 라스트마일 물류 서비스를 실증하고 디지털트윈 기반 구축</li>
                                                      <li>- 김천 드론 실증 도시 구축사업에 선정되어 드론 물류 및 응용서비스 사업화 실증 예정</li>
                                                  </ul>
                                                </div>
                                                    <img className='ssvImg1'  src='./images/service/Data/image28.png'alt=''/>
                                            </div>
                                            <div  className='servicePostCard5'>
                                                <p>주행소리 기반 도로노면위험 감지</p>
                                                <div className='tab_brackets2'></div>
                                                <div>
                                                  <ul>
                                                      <li>- 노면상태에 따른 차량 주행소리 특성에 기반해 AI가 노면을 실시간 판별하여 알림으로 사고 예방</li>
                                                      <li>- 성남시 실증, 원주지방국토관리청 설치 진행중, 김천 스마트타운 적용 예정</li>
                                                  </ul>
                                                </div>
                                                    <img src='./images/service/Data/image29.png'alt='' />
                                            </div>
                                            <div  className='servicePostCard5'>
                                                <p>디지털 트윈(공공선도, 팩토리)</p>
                                                <div className='tab_brackets2'></div>
                                                <div className="servicePostCard5_text">
                                                  <ul>
                                                      <li>- 대상 시설물 3D 모델링 및 시뮬레이션을 구현</li>
                                                      <li>- 경남TP, 경상남도/창원시/김해시 대상 시범 적용</li>
                                                      <li>- 팩토리 적용으로 생산계획 최적화, 안전시설 관리, CPS 모니터링 서비스 제공</li>
                                                  </ul>
                                                </div>
                                                    <img className='ssvImg1'  src='./images/service/Data/image30.png'alt=''/>
                                            </div>
                                            <div  className='servicePostCard5'>
                                                <p>대기질 관리 서비스</p>
                                                <div className='tab_brackets2'></div>
                                                <div>
                                                  <ul>
                                                      <li>- 화성시, 오산시 미세먼지 측정소 구축 운영 중</li>
                                                      <li>- 전국 항구 해경 함정 센서 설치로 해외 유입 미세먼지 먼지 측정</li>
                                                      <li>- 지하철 역사 미세먼지 센서 구축 및 측정</li>
                                                  </ul>
                                                </div>
                                                <div style={{display:'flex'}}>
                                                <img src='./images/service/Data/image31.png'alt='' style={{width:'40%'}}/>
                                                <img src='./images/service/Data/image32.png'alt='' style={{width:'60%'}}/>
                                                </div>
                                                    
                                        </div>
                                    </div>
                                </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Smartcity;
